/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Efforts_Detect_FtpInputs */

const en_ui_laps_efforts_detect_ftp = /** @type {(inputs: Ui_Laps_Efforts_Detect_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add FTP to detect efforts`)
};

const de_ui_laps_efforts_detect_ftp = /** @type {(inputs: Ui_Laps_Efforts_Detect_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FTP eintragen zum Erkennen`)
};

/**
* | output |
* | --- |
* | "Add FTP to detect efforts" |
*
* @param {Ui_Laps_Efforts_Detect_FtpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_detect_ftp = /** @type {((inputs?: Ui_Laps_Efforts_Detect_FtpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_Detect_FtpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_detect_ftp(inputs)
	return de_ui_laps_efforts_detect_ftp(inputs)
});